export const ZATRUDNIENIE_COURSE_NAME = 'Zatrudnienie w IT w Polsce';

export const isZatrudnienieCourse = (courseName?: string | null): boolean =>
  courseName === ZATRUDNIENIE_COURSE_NAME;
